import blog from './blocks/blog';
import cultureGap from './blocks/culture-gap';
import events from './blocks/events';
import hero from './blocks/hero';
import location from './blocks/location';
import slider from './blocks/slider';
import testimonials from './blocks/testimonials';
import chart1 from './blocks/chart1';

AOS.init( {
	once: true,
	startEvent: 'load'
} );

const headroom = new Headroom( document.querySelector( '.header-site' ), {
	offset: 200,
	tolerance: 5,
} );

headroom.init();

window.addEventListener( 'load', function() {
	AOS.refresh();

	initScripts();

	new Rellax( '.rellax', {
		center: true
	} );
} );

window.addEventListener( 'scroll', function() {
	AOS.refresh();
	//parallax.refresh();
} );

document.fonts.ready.then( function() {
	document.documentElement.classList.add( 'fonts-loaded' );
	Splitting();

	window.addEventListener( 'resize', () => {
		AOS.refresh();
		//parallax.refresh();
	} );
} );

// Add loaded class to document after site is fully loaded
window.addEventListener( 'load', function() {
	setTimeout( () => {
		document.documentElement.classList.add( 'site-loaded' );
	}, 100 ); // Small delay to ensure everything is properly rendered
} );

function initScripts() {
	const heroBlocks = document.querySelectorAll( '.b-hero' );
	if ( heroBlocks ) {
		heroBlocks.forEach( ( heroBlock ) => {
			hero( heroBlock );
		} );
	}

	const sliderBlocks = document.querySelectorAll( '.b-slider' );
	if ( sliderBlocks ) {
		sliderBlocks.forEach( ( sliderBlock ) => {
			slider( sliderBlock );
		} );
	}

	const testimonialsBlocks = document.querySelectorAll( '.b-testimonials' );
	if ( testimonialsBlocks ) {
		testimonialsBlocks.forEach( ( testimonialsBlock ) => {
			testimonials( testimonialsBlock );
		} );
	}

	const locationBlocks = document.querySelectorAll( '.b-location' );
	if ( locationBlocks ) {
		locationBlocks.forEach( ( locationBlock ) => {
			location( locationBlock );
		} );
	}

	const eventBlocks = document.querySelectorAll( '.b-events' );
	if ( eventBlocks ) {
		eventBlocks.forEach( ( eventBlock ) => {
			events( eventBlock );
		} );
	}

	const blogBlocks = document.querySelectorAll( '.b-blog' );
	if ( blogBlocks ) {
		blogBlocks.forEach( ( blogBlock ) => {
			blog( blogBlock );
		} );
	}

	const cultureGapBlocks = document.querySelectorAll( '.b-cgap' );
	if ( cultureGapBlocks ) {
		cultureGapBlocks.forEach( ( cultureGapBlock ) => {
			cultureGap( cultureGapBlock );
		} );
	}

	const chart1Blocks = document.querySelectorAll( '.b-ch1' );
	if ( chart1Blocks ) {
		chart1Blocks.forEach( ( chart1Block ) => {
			chart1( chart1Block );
		} );
	}

	const menuToggle = document.querySelector( '.header-toggle' );
	const close = document.querySelector( '.menu-site-close' );
	if ( menuToggle && close ) {
		menuToggle.addEventListener( 'click', function() {
			document.body.classList.add( 'site-menu-open' );
			console.log( 'header' );
		} );

		close.addEventListener( 'click', function() {
			document.body.classList.remove( 'site-menu-open' );
		} );
	}

	const menuItems = document.querySelectorAll( '.menu-item' );
	const menuSite = document.querySelector( '.menu-site' );
	const menuSubs = document.querySelectorAll( '.menu-site-submenu' );
	const menuBack = document.querySelectorAll( '.menu-site-submenu-back' );
	if ( menuItems && menuSite && menuSubs && menuBack ) {
		menuBack.forEach( ( back ) => {
			back.addEventListener( 'click', function() {
				menuSite.classList.remove( 'is-sub-open' );
				menuSubs.forEach( ( subItem ) => {
					subItem.classList.remove( 'is-active' );
				} );
			} );
		} );
		menuItems.forEach( ( item ) => {
			const menuLink = item.querySelector( 'a.has-children' );
			if ( menuLink ) {
				menuLink.addEventListener( 'click', function( e ) {
					e.preventDefault();
					menuSubs.forEach( ( subItem ) => {
						// Only proceed with the comparison if data-parent attribute exists
						if ( subItem.getAttribute( 'data-parent' ) === e.currentTarget.getAttribute( 'data-parent-id' ) ) {
							console.log( 'aa' );
							subItem.classList.add( 'is-active' );
						} else {
							subItem.classList.remove( 'is-active' );
						}
					} );
					menuSite.classList.add( 'is-sub-open' );
				} );
			}
		} );
	}

	const detailsElements = document.querySelectorAll( '.b-bespoke' );

	detailsElements.forEach( ( detail ) => {
		const content = detail.querySelector( '.b-bespoke-content' ); // Corrected selector
		let maxHeight = 2000; // Initial value

		// Set initial state if open
		if ( detail.hasAttribute( 'open' ) ) {
			maxHeight = content.scrollHeight + parseInt( getComputedStyle( content ).paddingTop ) + parseInt( getComputedStyle( content ).paddingBottom );
			content.style.maxHeight = maxHeight + 'px'; // Set actual height
			content.style.visibility = 'visible';
			content.style.opacity = '1';
			content.style.paddingBottom = 'var(--spacing)';
		}

		detail.addEventListener( 'click', ( e ) => {
			// Prevent default action on summary click
			e.preventDefault();

			// If opening
			if ( ! detail.hasAttribute( 'open' ) ) {
				detail.setAttribute( 'open', '' ); // Add open attribute
				detail.classList.remove( 'is-animating-close' );
				detail.classList.add( 'is-animating-open' );

				// Calculate actual height
				maxHeight = content.scrollHeight + parseInt( getComputedStyle( content ).paddingTop ) + parseInt( getComputedStyle( content ).paddingBottom );
				//content.style.maxHeight = maxHeight + 'px'; // Set height before animation
			} else {
				// If closing
				detail.classList.remove( 'is-animating-open' );
				detail.classList.add( 'is-animating-close' );

				// Remove open attribute after close animation ends
				content.addEventListener( 'animationend', () => {
					if ( detail.classList.contains( 'is-animating-close' ) ) {
						detail.removeAttribute( 'open' );
					}
				}, { once: true } );
			}
		} );
	} );

	// Use event delegation so the handler still runs if #bookTour is injected later
	document.addEventListener( 'click', function( e ) {
		const bookTourButton = e.target.closest( '#bookTour' );
		if ( ! bookTourButton ) return;
		console.log( 'clicked' );
		document.body.classList.add( 'hubspot-open' );
		document.body.classList.add( 'hubspot-booking' );
		document.body.classList.remove( 'hubspot-download' );
	} );
	// Delegated handling for dynamically added brochure download and close buttons
	document.addEventListener( 'click', function( e ) {
		const downloadBrochureButton = e.target.closest( '#downloadBrochure' );
		if ( downloadBrochureButton ) {
			document.body.classList.add( 'hubspot-open' );
			document.body.classList.remove( 'hubspot-booking' );
			document.body.classList.add( 'hubspot-download' );
		}

		const hubspotClose = e.target.closest( '#hubspotClose' );
		if ( hubspotClose ) {
			document.body.classList.remove( 'hubspot-open' );
			document.body.classList.remove( 'hubspot-booking' );
			document.body.classList.remove( 'hubspot-download' );
		}
	} );
}
